export const buildEvaluationSurveyLink = (
  portalDomain?: string | null,
  evaluationId?: string | null
) => {
  if (!portalDomain || !evaluationId) return evaluationId || "";

  const normalizedDomain = portalDomain.endsWith("/")
    ? portalDomain.slice(0, -1)
    : portalDomain;

  return `${normalizedDomain}/evaluationForm/${evaluationId}`;
};
